module.exports = __webpack_public_path__ + "img/workshop2.a07f62c5.jpg";